import React, { useEffect } from 'react';
import '../styles/Hero.css';

const Hero = () => {

  useEffect(() => {
    const handleScroll = () => {
      const bg = document.querySelector('.hero');
      if (bg) {
        bg.style.backgroundPositionY = `${window.scrollY * 0.4}px`;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="hero">
      <div className="hero-overlay" />
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title animate-fade">Калининград ждет! Исследуйте город и окрестности с комфортом — аренда авто от 1600₽/сутки</h1>
          <p className="animate-fade-delay">Без скрытых платежей, бесплатная отмена за 24 часа. Подберите идеальный автомобиль и откройте Куршскую косу, янтарный берег и исторические достопримечательности на своих условиях!</p>
          <a href="/cars" className="btn-hero animate-btn">Забронировать сейчас</a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
